import type { CheckboxDesignTokens, CheckboxTokenSections } from '@primeuix/themes/types/checkbox';

export const root: CheckboxTokenSections.Root = {
    borderRadius: '{borderRadius.xs}',  // guide radius-small (was 6px, off-scale)
    width: '1.25rem',
    height: '1.25rem',
    background: '{formField.background}',
    checkedBackground: '{primary.color}',
    checkedHoverBackground: '{primary.hoverColor}',
    disabledBackground: '{formField.disabledBackground}',
    filledBackground: '{formField.filledBackground}',
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hover.borderColor}',
    focusBorderColor: '{formField.focusBorderColor}',
    checkedBorderColor: '{primary.color}',
    checkedHoverBorderColor: '{primary.hoverColor}',
    checkedFocusBorderColor: '{primary.color}',
    checkedDisabledBorderColor: '{formField.borderColor}',
    invalidBorderColor: '{formField.invalid.borderColor}',
    shadow: '{formField.shadow}',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    },
    transitionDuration: '{formField.transitionDuration}',
    sm: {
        width: '1rem',
        height: '1rem'
    },
    lg: {
        width: '1.5rem',
        height: '1.5rem'
    }
};

export const icon: CheckboxTokenSections.Icon = {
    size: '0.75rem',
    color: '{formField.color}',
    checkedColor: '{primary.contrastColor}',
    checkedHoverColor: '{primary.contrastColor}',
    disabledColor: '{formField.disabled.color}',
    sm: {
        size: '0.625rem'
    },
    lg: {
        size: '0.875rem'
    }
};

export default {
    root,
    icon
} satisfies CheckboxDesignTokens;
